import {
  Box,
  Flex,
  Icon,
  Text,
} from '@chakra-ui/react'
import { RiMovie2Line } from "react-icons/ri";

const NavBar = () => {


  return (
    <Box color='bmp.primary'>
      <Flex p={4} >
        <Icon boxSize={10} as={RiMovie2Line} />
        <Box alignSelf={'center'}>
          <Text fontSize='xl' pl={1} as={'b'} >B Movie Player</Text>
        </Box>
      </Flex>

    </Box >
  )
}

export default NavBar;

